import { emailRegex as email } from "src/itsf/regex";
import { i18n } from "@translations/i18n";
import { differenceInYears, format, parse } from "date-fns";

// Wrap a regex using this function if the field is optional
export const optional = (regex: (value: string) => string | undefined) => (value?: string) =>
    value ? regex(value) : undefined;

export const specialAlphaNumericRegex = (value: string) =>
    value && /^[\p{L}\s]+$/u.test(value) ? undefined : i18n.t("control:onlyLetters");

//export const phoneRegex = (value: string) => (/^(0[1-9][\d]{7,11})$/.test(value) ? undefined : i18n.t("control:phone"));

export const phoneRegex = (value: string) => (/^\d{7,11}$/.test(value) ? undefined : i18n.t("control:phone"));

export const optionalPhoneRegex = optional(phoneRegex);

export const emailMustMatch = (value: string, emailValue: string | undefined) =>
    value !== emailValue ? i18n.t("control:emailMustMatch") : undefined;

/*export const dateFormatRegex = (value: string) =>
    value && /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/i.test(value)
        ? undefined
        : i18n.t("control:incorrectDateFormat");*/

export const dateFormatRegex = (value: string) =>
    value && /^(0[1-9]|1[0-2])\/\d{4}$/i.test(value) ? undefined : i18n.t("control:incorrectDateFormat");

export const minYearValid = (value: string) =>
    value && parse("01/" + value, "dd/MM/yyyy", new Date()).getFullYear() >= 1900
        ? undefined
        : i18n.t("control:minYear");

export const maxYearValid = (value: string) =>
    value && parse("01/" + value, "dd/MM/yyyy", new Date()).getFullYear() <= new Date().getFullYear()
        ? undefined
        : i18n.t("control:maxYear", { date: format(new Date(), "yyyy") });

export const over18Valid = (value: string) =>
    differenceInYears(new Date(), parse("01/" + value, "dd/MM/yyyy", new Date())) >= 18
        ? undefined
        : i18n.t("control:over18");

export const noSpacesRegex = (value: string) =>
    value !== "" && !/\s/.test(value) ? undefined : i18n.t("control:invalidEmailSpace");

export const emailRegex = (value: string) =>
    value !== "" && email.test(value) ? undefined : i18n.t("control:invalidEmail");

export const OTPnoSpacesRegex = (value: string) => (value !== "" && !/\s/.test(value) ? true : false);

export const OTPemailRegex = (value: string) => (value !== "" && email.test(value) ? true : false);
